import {Nav, Button, Offcanvas, Col} from 'react-bootstrap';
import i18n from '../../plugins/i18n';

import {useEffect, useState} from 'react';

function DashboardTabs({ currentView, changeView, userGroup }) {

    const [activeTab, setActiveTab] = useState('user')
    const [showSidebar, setShowSidebar] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const updateWindowDimensions = () => {
        const newWidth = window.innerWidth;
        setWindowWidth(newWidth);
      };
      window.addEventListener("resize", updateWindowDimensions);
      return () => window.removeEventListener("resize", updateWindowDimensions) 
    }, []);

    useEffect(()=>{
        let tabs = document.getElementsByClassName('tab-item')
        for (let i = 0; i < tabs.length; i++) {
            if(!tabs[i].href.includes(`#${currentView}`))
                tabs[i].classList.remove('active')
        }
        setActiveTab(currentView)
    },[currentView])

    const whenChangeView = (model) => {
        changeView(model)
        setShowSidebar(false)
    }

    return <>
        {windowWidth > 900 ? 
            <Nav id="iminio-dashboard-tabs-container" variant="underline" defaultActiveKey="#user" className='bg-orange px-4'>
                {userGroup !== 'admin' ? '' : 
                <Nav.Item  className="me-4" onClick={()=>setActiveTab('user')}>
                    <Nav.Link href="#user" className={`tab-item ${windowWidth<900? 'px-1 text-8' : 'px-3'} ${activeTab !== 'user' ? '' : 'active'}`} onClick={()=>whenChangeView('user')}><h5 className="">{i18n.t('models.user.plural')}</h5></Nav.Link>
                </Nav.Item>}
                {userGroup !== 'admin' ? '' : 
                <Nav.Item className="me-4" onClick={()=>setActiveTab('condominium')}>
                    <Nav.Link href="#condominium" className={`tab-item ${windowWidth<900? 'px-1 text-8' : 'px-3'} ${activeTab !== 'condominium' ? '' : 'active'}`} onClick={()=>whenChangeView('condominium')}><h5 className="">{i18n.t('models.condominium.plural')}</h5></Nav.Link>
                </Nav.Item>}
                {userGroup !== 'admin' ? '' : 
                <Nav.Item className="me-4" onClick={()=>setActiveTab('admin')}>
                    <Nav.Link href="#admin" className={`tab-item ${windowWidth<900? 'px-1 text-8' : 'px-3'} ${activeTab !== 'admin' ? '' : 'active'}`} onClick={()=>whenChangeView('admin')}><h5 className="">{i18n.t('models.admin.plural')}</h5></Nav.Link>
                </Nav.Item>}
                <Nav.Item className="" onClick={()=>setActiveTab('technical_intervention')}>
                    <Nav.Link href="#technical_intervention" className={`tab-item ${windowWidth<900? 'px-1 text-8' : 'px-3'} ${activeTab !== 'technical_intervention' ? '' : 'active'}`} onClick={()=>whenChangeView('technical_intervention')}><h5 className="">{i18n.t('models.technical_intervention.plural')}</h5></Nav.Link>
                </Nav.Item>
                {userGroup !== 'technician' ? '' : 
                <Nav.Item className="" onClick={()=>setActiveTab('condominium')}>
                    <Nav.Link href="#condominium" className={`tab-item ${windowWidth<900? 'px-1 text-8' : 'px-3'} ${activeTab !== 'condominium' ? '' : 'active'}`} onClick={()=>whenChangeView('condominium')}><h5 className="">{i18n.t('models.condominium.plural')}</h5></Nav.Link>
                </Nav.Item>}
                {userGroup !== 'technician' ? '' :
                <Nav.Item className="" onClick={()=>setActiveTab('profile-form')}>
                    <Nav.Link href="#profile-form" className={`tab-item ${windowWidth<900? 'px-1 text-8' : 'px-3'} ${activeTab !== 'profile-form' ? '' : 'active'}`} onClick={()=>whenChangeView('profile-form')}><h5 className="">{i18n.t('words.profile')}</h5></Nav.Link>
                </Nav.Item>
                }
            </Nav>
        :
        <>
            <Col id="iminio-dashboard-tabs-container" xs={3} sm={2} className='bg-orange'>
                <Button variant="orange" className='bg-orange fg-white' onClick={()=>setShowSidebar(true)}>
                    <i className="mdi mdi-menu text-12"></i>
                </Button>
            </Col>

            <Offcanvas show={showSidebar} onHide={()=>setShowSidebar(false)}>
                <Offcanvas.Header closeButton className="bg-orange">
                    <Offcanvas.Title className="fg-white">Seleziona Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Col>
                        {userGroup !== 'admin' ? '' : 
                        <Nav.Item  className="me-4" onClick={()=>setActiveTab('user')}>
                            <Nav.Link 
                                href="#user" 
                                className={`fg-text ${'pl-1 py-3 text-12'} ${activeTab !== 'user' ? '' : 'active'}`} 
                                onClick={()=>whenChangeView('user')}
                            >
                                <h5 className="">{i18n.t('models.user.plural')}</h5>
                            </Nav.Link>
                        </Nav.Item>}
                        <Nav.Item className="me-4" onClick={()=>setActiveTab('condominium')}>
                            <Nav.Link 
                                href="#condominium" 
                                className={`fg-text ${'pl-1 py-3 text-12'} ${activeTab !== 'condominium' ? '' : 'fg-orange'}`} 
                                onClick={()=>whenChangeView('condominium')}>
                                    <h5 className="">{i18n.t('models.condominium.plural')}</h5>
                            </Nav.Link>
                        </Nav.Item>
                        {userGroup !== 'admin' ? '' : 
                        <Nav.Item className="me-4" onClick={()=>setActiveTab('admin')}>
                            <Nav.Link 
                                href="#admin" 
                                className={`fg-text ${'pl-1 py-3 text-12'} ${activeTab !== 'admin' ? '' : 'fg-orange'}`} 
                                onClick={()=>whenChangeView('admin')}>
                                    <h5 className="">{i18n.t('models.admin.plural')}</h5>
                            </Nav.Link>
                        </Nav.Item>}
                        <Nav.Item className="" onClick={()=>setActiveTab('technical_intervention')}>
                            <Nav.Link 
                                href="#technical_intervention" 
                                className={`fg-text ${'pl-1 py-3 text-12'} ${activeTab !== 'technical_intervention' ? '' : 'fg-orange'}`} 
                                onClick={()=>whenChangeView('technical_intervention')}>
                                    <h5 className="">{i18n.t('models.technical_intervention.plural')}</h5>
                            </Nav.Link>
                        </Nav.Item>
                        {userGroup !== 'technician' ? '' :
                        <Nav.Item className="" onClick={()=>setActiveTab('profile-form')}>
                            <Nav.Link 
                                href="#profile-form" 
                                className={`fg-text ${'pl-1 py-3 text-12'} ${activeTab !== 'profile-form' ? '' : 'fg-orange'}`} 
                                onClick={()=>whenChangeView('profile-form')}
                                >
                                <h5 className="">{i18n.t('words.profile')}</h5>
                            </Nav.Link>
                        </Nav.Item>
                        }
                    </Col>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    }
    </>
}

export default DashboardTabs